import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { TelephonyProvider } from '../../providers/telephony/telephony.provider';
import { TelephonyStateService } from '../../providers/telephony/telephony.state.service';
import { CampaignService } from '../../services/campaign.service';
@Component({
  selector: 'app-incoming-call',
  templateUrl: './incoming-call-updated.component.html',
  styleUrls: ['./incoming-call.component.scss'],
})
export class IncomingCallComponent implements OnInit, OnDestroy {
  @Input() draggable: boolean = true;
  subscription = new Subscription();
  loading: boolean = false;
  constructor(
    public campaignService: CampaignService,
    private telephony: TelephonyProvider,
    public telephonyState: TelephonyStateService
  ) {}
  ngOnInit(): void {
    this.subscription.add(
      this.telephony.voice.events.subscribe((event) => {
        switch (event.type) {
          case 'Reservation':
            switch (event.name) {
              case 'reservation-init':
                this.loading = true;
                break;
              case 'created':
              case 'accepted':
              case 'rejected':
              case 'timeout':
              case 'canceled':
              case 'rescinded':
              case 'error':
                this.loading = false;
                break;
            }
            break;
        }
      })
    );
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
  acceptCall() {
    if (!this.loading) this.telephony.voice.acceptCall(null);
  }
  rejectCall() {
    if (!this.loading) this.telephony.voice.rejectCall(null);
  }
}
